var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.762 8.847 19.169 7l.005.014-2.056.404-6.614 5.474-3.122 1.045.735 4.416-.736-4.416-1.287 1.375-2.333.027-1.146 2.143L1 17.948l1.524.25 1.429-1.895 2.15.43.007 2.018-1.099 2.96-.626 2.737-.674 1.092 1.74-.358-.223-1.14 1.451-3.002 2.81-1.13 1.085-1.8 1.834-1.342 3.694.62 3.554-1.644-.566 2.494-1.659.101-.44 2.143 1.403-.937 2.306-1.004 1.846-2.818.074-1.362.978 1.01 2.825 1.767 1.685-.776-.182-3.735-.422-1.372 2.06-.604L31 8.88l-.06-1.01-.297.842-1.672 1.463-1.94.252-.527-.474L28.155 7.6l2.117-.587-2.252.115-2.75 1.928-2.508-.209zm2.562 1.8 1.253.883-3.815-2.683 2.562 1.8z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoly);
export default __webpack_public_path__ + "static/media/POLY.a579fc994da21f9cb9b93b30b9e770b2.svg";
export { ForwardRef as ReactComponent };